import { render, staticRenderFns } from "./subs__form.vue?vue&type=template&id=6dbdc3e4"
import script from "./subs__form.vue?vue&type=script&lang=js"
export * from "./subs__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports